import { FormProvider, useForm } from 'react-hook-form';

import { CfsApi } from '@/api';
import { TabLayoutContextProvider } from '@/layouts/TabLayout';
import { MasterVehicleContextProvider } from '@/layouts/TabLayout/MasterVehicles';
import MasterVehicleForm, {
  MasterVehicleFormData,
} from '@/layouts/TabLayout/MasterVehicles/components/MasterVehicleForm';

interface AddVehiclePanelProps {
  onClose: () => void;
  cfsId: string;
}

const AddVehiclePanel = ({ onClose, cfsId }: AddVehiclePanelProps) => {
  const methods = useForm<MasterVehicleFormData>({
    mode: 'all',
    defaultValues: {
      make: '',
      model: '',
      isVerified: false,
    },
  });

  return (
    <TabLayoutContextProvider>
      <MasterVehicleContextProvider
        nextRoutes={[]}
        addLinkedVehicles={(vehicleId: string) =>
          CfsApi.addCfsMasterVehicle(cfsId, vehicleId)
        }
      >
        <FormProvider {...methods}>
          <MasterVehicleForm goBack={onClose} />
        </FormProvider>
      </MasterVehicleContextProvider>
    </TabLayoutContextProvider>
  );
};

export default AddVehiclePanel;
